// Api End Point
export const URL = 'soilsampling/point/'

// State Configuration
export const MODEL = 'SamplingPoints'
export const TREE = 'soilJobData'
export const BRANCH = 'soilPoints'

export const OPERATION_TREE = 'soilJobsModule'
export const OPERATION_BRANCH = 'samplingPointOperation'

// Model Properties
export const PROP_ID = 'id'
export const PROP_SAMPLING_POINT_ID = PROP_ID
export const PROP_LATITUDE = 'latitude'
export const PROP_LONGITUDE = 'longitude'
export const PROP_SAMPLED_DATE = 'sampledDate'
export const PROP_SAMPLING_TYPE = 'samplingType'
export const PROP_GRID_ID = 'gridId'
export const PROP_MANAGEMENT_ZONE = 'managementZone'
export const PROP_JOB = 'job'

export const PROP_SAMPLED_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss' // 2017-05-17T20:17:37
